import Client from "../client";
import TaskType from "@/entities/task-type";
import TaskTypeGateway from "@/usecases/gateways/task-type-gateway";
import { TaskTypeId, ProjectId } from "@/entities/ids";

export default class TaskTypeApi implements TaskTypeGateway {
  public constructor(private client: Client) {}

  public async all(): Promise<TaskType[]> {
    const list = await this.client.get("get_all_task_types.php");
    return list.map(toTaskType);
  }

  public async findByProject(projectId: ProjectId): Promise<TaskType[]> {
    const list = await this.client.get("get_task_types_of_project.php", {
      projectId
    });
    return list.map(toTaskType);
  }

  public async save(tasktype: TaskType) {
    const d = new FormData();
    d.append("id", String(tasktype.id));
    d.append("name", tasktype.name);
    d.append("serviceTemplateTypeId", tasktype.serviceTemplateTypeId);
    await this.client.post("save_task_type.php", d);
  }

  public async remove(id: TaskTypeId) {
    const d = new FormData();
    d.append("taskTypeId", String(id));
    await this.client.post("delete_task_type.php", d);
  }

  public async sort(ids: TaskTypeId[]) {
    const d = new FormData();
    ids.forEach((id, i) => {
      d.append(`ids[${i}]`, String(id));
    });
    await this.client.post("sort_task_types.php", d);
  }
}

function toTaskType(t: any): TaskType {
  return {
    id: t.taskTypeId,
    name: t.name,
    serviceTemplateTypeId: t.serviceTemplateTypeId
  };
}
